<div class="wrapper__headerComponent container my-5">
  <div class="row align-items-center">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-6">
      <h2 class="text-center h3-tipografia-govco mb-0">
        {{ 'anexos.avance-procesal.detalle' | translate }}
      </h2>
    </div>
    <div class="col-12 col-md-6">
      <h5 class="h5-tipografia-govco mb-0"
        *ngIf="avanceProcesalItem.Fecha_solicitud">
        {{ 'anexos.avance-procesal.solicitud' | translate }}
        {{ avanceProcesalItem.Fecha_solicitud | date: 'dd/MM/yyyy' : 'GMT' }}
      </h5>
      <h5 class="h5-tipografia-govco mb-0"
        *ngIf="avanceProcesalItem.Asunto">
        {{ 'anexos.avance-procesal.asunto' | translate }}
        {{ avanceProcesalItem.Asunto }}
      </h5>
    </div>
  </div>
</div>
<div
  class="wrapper__contentComponent--expediente container my-5"
  id="encabezado">
  <app-encabezado-expediente></app-encabezado-expediente>
</div>
<div class="wrapper__contentComponent--expediente container my-5">
  <div class="contenedor-tabla w-100">
    <app-table
      [estiloEncabezado]="'height: auto !important;'"
      [datos]="anexosList"
      [paginaActual]="currentPage"
      [columnas]="columns"
      [paginacion]="true"
      [tamano]="pageSize"
      [totalPaginas]="totalPages"
      [tamanos]="[1, 5, 10, 20]"></app-table>
  </div>
</div>
